import { Grid } from "@mui/material";
import { StyledHeaderLabel } from "../../styled/Layout";

const HeaderLabel = ({ children }) => {

  return (
    <Grid container spacing={2}>
      <Grid item xs={true}>
        <StyledHeaderLabel.PaperOutlined elevation={2}>
          <StyledHeaderLabel.HeaderDiv>{children}</StyledHeaderLabel.HeaderDiv>
        </StyledHeaderLabel.PaperOutlined>
      </Grid>
    </Grid>
  );
};

export default HeaderLabel;
